import React from 'react';
import { motion } from 'framer-motion';
import { Plane, Ticket, Coins, Compass, Globe } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-96">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-97">
        <div className="mt-4 mb-12 bg-brand-brown-light p-12 md:p-16 rounded-[3rem] border-2 border-brand-gold shadow-2xl relative overflow-hidden" data-id="element-98">
          {/* Decorative gold corners */}
          <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-brand-gold rounded-tl-[2rem]" data-id="element-99"></div>
          <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-brand-gold rounded-tr-[2rem]" data-id="element-100"></div>
          <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-brand-gold rounded-bl-[2rem]" data-id="element-101"></div>
          <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-brand-gold rounded-br-[2rem]" data-id="element-102"></div>

          {/* Floating travel icons — hand-drawn feel in soft gold */}
          <Plane className="absolute top-10 left-10 w-7 h-7 text-brand-gold/30 -rotate-12 pointer-events-none" strokeWidth={1} data-id="element-103" />
          <Ticket className="absolute top-12 right-12 w-7 h-7 text-brand-cream/25 rotate-12 pointer-events-none" strokeWidth={1} data-id="element-104" />
          <Coins className="absolute bottom-16 left-12 w-7 h-7 text-brand-gold/30 -rotate-6 pointer-events-none" strokeWidth={1} data-id="element-105" />
          <Compass className="absolute bottom-14 right-10 w-7 h-7 text-brand-cream/25 rotate-12 pointer-events-none" strokeWidth={1} data-id="element-106" />
          <Globe className="absolute top-1/2 left-6 w-6 h-6 text-brand-gold/25 pointer-events-none hidden md:block" strokeWidth={1} data-id="element-107" />
          <Plane className="absolute top-1/2 right-6 w-6 h-6 text-brand-cream/20 rotate-45 pointer-events-none hidden md:block" strokeWidth={1} data-id="element-108" />

          <img src="https://cdn.magicpatterns.com/uploads/wGuZgXmUeTEHMANTTKmea7/ChatGPT_Image_18_may_2026,_04_05_24_p.m..png" alt="Atajo al Éxito - Mentoría 1:1 by Careliz Griman" className="relative mx-auto w-60 md:w-72 h-auto mb-8 rounded-lg shadow-md" data-id="element-109" />

          <p className="text-sm uppercase tracking-[0.3em] text-brand-gold mb-6 font-medium" data-id="element-110">
            Tu Inversión
          </p>

          <p className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-gold mb-8 leading-tight" data-id="element-111">
            30 minutos
            <br data-id="element-112" />
            <span className="text-2xl md:text-3xl italic font-normal text-brand-gold/85" data-id="element-113">
              de tu tiempo
            </span>
          </p>

          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-114">
            <div className="w-16 h-px bg-brand-gold/60" data-id="element-115"></div>
            <span className="text-brand-gold text-xs" data-id="element-116">✦</span>
            <div className="w-16 h-px bg-brand-gold/60" data-id="element-117"></div>
          </div>

          <p className="text-xl md:text-2xl font-serif text-brand-cream italic leading-relaxed max-w-xl mx-auto mb-10" data-id="element-118">
            Estás a una llamada para darle{' '}
            <span className="text-brand-gold not-italic font-medium" data-id="element-119">
              cambio
            </span>{' '}
            y{' '}
            <span className="text-brand-gold not-italic font-medium" data-id="element-120">
              dirección
            </span>{' '}
            a tu vida.
          </p>

          <a href="https://wa.me/message/LI4MMCWOOCMYN1" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'Atajo al Éxito - Llamada 30 min',
          source: 'pricing-section'
        })} className="btn-gold-shine inline-block px-10 py-5 rounded-full uppercase tracking-widest text-sm font-bold w-full md:w-auto" data-id="element-121">
            Agendar mi llamada de 30 minutos ahora
          </a>
        </div>
      </motion.div>
    </section>;
}